

"use client";

import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import styles from "./Promotion.module.scss";

export default function Promotion({ image, mobileImage, text, alt = "Promotion", width = 1920, height = 840 }) {
  const [offset, setOffset] = useState(0);
  const [reducedMotion, setReducedMotion] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const sectionRef = useRef(null);
  const imageRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    // Check for reduced motion preference
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReducedMotion(mediaQuery.matches);

    // Check for mobile
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();

    const handleResize = () => checkMobile();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (reducedMotion) return;

    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        rafRef.current = requestAnimationFrame(() => {
          if (sectionRef.current) {
            const rect = sectionRef.current.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            
            // Only apply parallax when section is in or near viewport
            if (rect.top < windowHeight && rect.bottom > 0) {
              // Calculate parallax offset (10-20% slower than scroll)
              // Negative value makes image move slower than scroll
              const scrollSpeed = isMobile ? 0.05 : 0.15; // More subtle on mobile
              const parallaxOffset = -rect.top * scrollSpeed;
              setOffset(parallaxOffset);
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Initial call

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
    };
  }, [reducedMotion, isMobile]);

  return (
    <section className={styles.promotion} ref={sectionRef}>
      <div className={styles.imageContainer}>
        <div
          ref={imageRef}
          className={styles.imageWrapper}
          style={{
            transform: reducedMotion ? "none" : `translateY(${offset}px)`,
          }}
        >
          <picture>
            {mobileImage && <source media="(max-width: 767px)" srcSet={mobileImage} />}
            <Image
              src={image}
              alt={alt}
              width={width}
              height={height}
              className={styles.image}
              priority
            />
          </picture>
        </div>
      </div>
      <div className={styles.label}>
        {text && <span className={styles.line}></span>}
        <p>{text}</p>
      </div>
    </section>
  );
}


/* "use client";

import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import styles from "./Promotion.module.scss";

export default function Promotion({ image, mobileImage, text, alt = "Promotion", width = 1920, height = 740 }) {
  const [offset, setOffset] = useState(0);
  const [reducedMotion, setReducedMotion] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const sectionRef = useRef(null);
  const imageRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    // Check for reduced motion preference
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReducedMotion(mediaQuery.matches);

    // Check for mobile
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();

    const handleResize = () => checkMobile();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (reducedMotion) return;

    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        rafRef.current = requestAnimationFrame(() => {
          if (sectionRef.current) {
            const rect = sectionRef.current.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            
            // Only apply parallax when section is in or near viewport
            if (rect.top < windowHeight && rect.bottom > 0) {
              // Calculate parallax offset (10-20% opposite to scroll)
              // Positive value makes image move opposite to scroll
              const scrollSpeed = isMobile ? 0.05 : 0.15; // More subtle on mobile
              const parallaxOffset = rect.top * scrollSpeed;
              setOffset(parallaxOffset);
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Initial call

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
    };
  }, [reducedMotion, isMobile]);

  return (
    <section className={styles.promotion} ref={sectionRef}>
      <div className={styles.imageContainer}>
        <div
          ref={imageRef}
          className={styles.imageWrapper}
          style={{
            transform: reducedMotion ? "none" : `translateY(${offset}px)`,
          }}
        >
          <picture>
            {mobileImage && <source media="(max-width: 767px)" srcSet={mobileImage} />}
            <Image
              src={image}
              alt={alt}
              width={width}
              height={height}
              className={styles.image}
              priority
            />
          </picture>
        </div>
      </div>
      <div className={styles.label}>
        {text && <span className={styles.line}></span>}
        <p>{text}</p>
      </div>
    </section>
  );
}

*/